module.exports = __webpack_public_path__ + "static/faq4-190c306bd027753a34e339b2e29c0ba3.jpg";